import React from "react";
import styled, { css } from "styled-components";
import Text from "../Text";
import * as colors from "../../assets/_base/colors";
import IconButton from "../IconButton";

const AlertContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Alert = styled.div`
  background-color: ${colors.danger};
  position: absolute;
  z-index: 9999999 !important;
  margin-top: -8px !important;
  top: 0;
  padding: 10px;
  border-radius: 5px;

  * {
    color: ${colors.dark} !important;
  }

  ${(props) => {
    if (props.type === "danger") {
      return css`
        background-color: ${colors.danger};
      `;
    } else if (props.type === "info") {
      return css`
        background-color: ${colors.lightBlue};
      `;
    } else if (props.type === "success") {
      return css`
        background-color: ${colors.success} !important;
        > .alert-middle-text-halsk * {
          color: white;
        }
      `;
    }
  }}
`;

const CloseButtonContainerd = styled.div`
  display: flex;
  justify-content: end;
`;
const CloseIconButton = styled(IconButton)`
  color: white;
  margin-top: -20px !important;
  margin-rigth: -100px !important;
  margin-bottom: 5px;
`;

export default (props) => {
  const [show, setShow] = React.useState(false);

  function onShow() {
    //console.debug(props.show);
    setShow(props.show === true);
    setTimeout(() => {
      if (!show) {
        setShow(false);
      }
    }, props.timeout || 4000);
  }
  React.useEffect(onShow, [props.show]);
  if (!show) {
    return <div />;
  }
  return (
    <AlertContainer>
      <Alert {...props}>
        <Text className="alert-middle-text-halsk">{props.message}</Text>
      </Alert>
    </AlertContainer>
  );
};



// WEBPACK FOOTER //
// ./src/_components/Alert/index.jsx